module.exports = __webpack_public_path__ + "media/images/flags/cn-c8f9e31c38811742c182829fde86d0f3.svg";